import { render, staticRenderFns } from "./out-tag.vue?vue&type=template&id=39f99eb9&scoped=true&"
import script from "./out-tag.vue?vue&type=script&lang=js&"
export * from "./out-tag.vue?vue&type=script&lang=js&"
import style0 from "./out-tag.vue?vue&type=style&index=0&id=39f99eb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f99eb9",
  null
  
)

export default component.exports